"use client";

import clsx from "clsx";
import { RiskLevel } from "@/stores/strategiesStore";

interface RiskBadgeProps {
  level: RiskLevel;
}

const riskConfig = {
  low: {
    label: "Low Risk",
    className: "text-emerald-400",
  },
  medium: {
    label: "Medium Risk",
    className: "text-amber-400",
  },
  high: {
    label: "High Risk",
    className: "text-rose-400",
  },
};

export const RiskBadge = ({ level }: RiskBadgeProps) => {
  const config = riskConfig[level];

  return (
    <span className={clsx("text-xs font-medium", config.className)}>{config.label}</span>
  );
};
